import Widget from 'services/widget/Widget';

const TICKER = 'TICKER';
const SLIDER = 'SLIDER';
const LIST = 'LIST';

class TopDonorsWidget extends Widget {
  static topDonorsNumberList = [5, 10, 15];
  static topDonorsTypeList = [
    {
      key: TICKER,
      value: 'common.ticker',
    },
    {
      key: SLIDER,
      value: 'common.slider',
    },
    {
      key: LIST,
      value: 'common.list',
    },
  ];

  constructor() {
    super();

    this.code = null;
    this.topDonorsNumber = 5;
    this.topDonorsType = TICKER;
    this.type = 'TOP_DONORS';
    this.showSum = true;
  }

  setData(data) {
    this.code = data?.code;
    this.topDonorsNumber = data?.topDonorsNumber;
    this.topDonorsType = data?.topDonorsType;
    this.showSum = data?.showSum;
  }

  getData() {
    return {
      code: this.code,
      topDonorsNumber: this.topDonorsNumber,
      topDonorsType: this.topDonorsType,
      type: this.type,
      status: this.status,
      showSum: this.showSum,
    };
  }
}

export default TopDonorsWidget;
